var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsychology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3062_6155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 8.57007C12.2101 8.57007 11.5701 9.21007 11.5701 10.0001C11.5701 10.7901 12.2101 11.4301 13.0001 11.4301C13.7901 11.4301 14.4301 10.7901 14.4301 10.0001C14.4301 9.21007 13.7901 8.57007 13.0001 8.57007Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 3C9.25007 3 6.20007 5.94 6.02007 9.64L4.10007 12.2C3.85007 12.53 4.09007 13 4.50007 13H6.00007V16C6.00007 17.1 6.90007 18 8.00007 18H9.00007V21H16.0001V16.32C18.3601 15.2 20.0001 12.79 20.0001 10C20.0001 6.13 16.8701 3 13.0001 3ZM16.0001 10C16.0001 10.13 15.9901 10.26 15.9801 10.39L16.8101 11.05C16.8901 11.11 16.9101 11.21 16.8601 11.3L16.0601 12.69C16.0101 12.78 15.9001 12.81 15.8201 12.78L14.8301 12.38C14.6201 12.54 14.4001 12.67 14.1601 12.77L14.0001 13.83C13.9901 13.93 13.9001 14 13.8001 14H12.2001C12.1001 14 12.0201 13.93 12.0001 13.83L11.8501 12.77C11.6001 12.67 11.3801 12.54 11.1701 12.38L10.1801 12.78C10.0901 12.81 9.98007 12.78 9.93007 12.69L9.13007 11.3C9.08007 11.22 9.10007 11.11 9.18007 11.05L10.0201 10.39C10.0101 10.26 10.0001 10.13 10.0001 10C10.0001 9.87 10.0201 9.73 10.0401 9.61L9.19007 8.95C9.11007 8.89 9.09007 8.79 9.14007 8.69L9.94007 7.31C9.99007 7.22 10.0901 7.19 10.1801 7.22L11.1801 7.62C11.3801 7.47 11.6101 7.33 11.8501 7.23L12.0001 6.17C12.0201 6.07 12.1001 6 12.2001 6H13.8001C13.9001 6 13.9801 6.07 14.0001 6.17L14.1501 7.23C14.3901 7.33 14.6101 7.46 14.8201 7.62L15.8201 7.22C15.9101 7.19 16.0201 7.22 16.0601 7.31L16.8601 8.69C16.9101 8.78 16.8901 8.89 16.8101 8.95L15.9601 9.61C15.9901 9.73 16.0001 9.86 16.0001 10Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3062_6155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychology);
export default __webpack_public_path__ + "static/media/psychology.b9ac6bd5e32b98d8381c296db2595426.svg";
export { ForwardRef as ReactComponent };